import {DateTime} from 'luxon'
import type {Maybe, ValueLabelPair} from '../types'

const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  CHF: 'CHF',
  GBP: '£',
  EUR: '€',
}

const defaultCurrencySymbol = CURRENCY_SYMBOLS['EUR']

export function encodeBase64(data: any) {
  return btoa(encodeURIComponent(JSON.stringify(data)))
}

export function decodeBase64(data: string) {
  return JSON.parse(decodeURIComponent(atob(data)))
}

export function deepCopyData(object: any) {
  return JSON.parse(JSON.stringify(object))
}

export function isNotNullOrUndefined<T>(value: Maybe<T>): value is T {
  return !isNullOrUndefined(value)
}

export function isNullOrUndefined(value: any): value is null | undefined {
  return value === null || value === undefined
}

export function last<T>(values: T[]): Maybe<T> {
  return values.slice(-1)[0]
}

export function safeJsonParse(s: string) {
  try {
    return JSON.parse(s)
  } catch {
    return s
  }
}

export function extractCurrencySymbol(s: Maybe<string>): string {
  return CURRENCY_SYMBOLS[s ?? 'EUR'] ?? defaultCurrencySymbol
}

export const isEmptyArray = (array: ArrayLike<unknown>) => array.length === 0

export function uniqueDates(dates: Date[]): Date[] {
  const set = dates.reduce((acc, date) => {
    if (!acc.has(date.getTime())) {
      acc.add(date.getTime())
    }
    return acc
  }, new Set<number>())
  return Array.from(set).map((time) => new Date(time))
}

export const startOfDay = (date: Date) => DateTime.fromJSDate(date).startOf('day').toJSDate()
export const toValueLabelPair = (value: string): ValueLabelPair<string> => ({value, label: value})
export const labelSorter = (a: ValueLabelPair, b: ValueLabelPair) => a.label.localeCompare(b.label)
